export const environment = {
  production: true,
  BASE_URL:'https://uat.contractor.controlfms.com/',
  encrypt_passcode : '6478'
};
